define('services/auth/index',['require','exports','module','./ticket','./info','./handler','./filter','./company','./trial'],function (require, exports, module) {
  'use strict';

  var AuthTicket = require('./ticket'),
    AuthInfo = require('./info'),
    AuthHandler = require('./handler'),
    AuthFilter = require('./filter'),
    AuthCompany = require('./company'),
    AuthTrial = require('./trial'),
    // auth token expires in 1h
    // php session expires in 24'
    TIME_BEFORE_EXPIRE = 40 * 60 * 1000, // ~ each 20', before than php session
    DEBUG = false,
    lastCompanyId,
    log = function (msg) {
      if (DEBUG) {
        console.log(msg);
      }
    };

  module.exports = function (
    config,
    authInfo,
    authTicket,
    authHandler,
    authFilter,
    getCompanyId,
    authCompany,
    authTrial
  ) {
    authInfo = authInfo || new AuthInfo();
    authTicket = authTicket || new AuthTicket(config);
    authHandler = authHandler || new AuthHandler(config);
    authFilter = authFilter || new AuthFilter(authInfo, authHandler);
    authCompany = authCompany || new AuthCompany(config);
    authTrial = authTrial || new AuthTrial();
    getCompanyId =
      getCompanyId ||
      function () {
        var companyId = location.search.split('company_id=')[1];
        if (companyId) {
          companyId = companyId.split('&')[0];
        }
        return companyId;
      };

    return {
      _timeout: null,

      login: function (callback) {
        var self = this;
        var companyId = getCompanyId();
        if (companyId) {
          lastCompanyId = companyId;
        }
        authInfo.initFromLocalStorage();

        if (!authInfo.isValid() || authInfo.expiresInLessThan(TIME_BEFORE_EXPIRE) || companyId) {
          return this._newLogin(function (isLogged) {
            self._afterLogin(isLogged, callback);
          });
        }
        log('auth: login from localStorage...');
        return this._afterLogin(true, callback);
      },

      _newLogin: function (callback) {
        var companyId = lastCompanyId || authInfo.getCompanyId();
        var callbackOk = function (response) {
            authInfo.init(response.result);
            authInfo.save();
            if (window.location.pathname === '/' && window.location.search === '') {
              window.location = '/?company_id=' + authInfo.getCompanyId();
            } else {
              callback(true);
            }

          },
          callbackError = function (err) {
            callback(false);
            authInfo.clear();
            authHandler.handle(err.status);
          };
        log('auth: new login , companyId=' + companyId);
        authTicket.get(callbackOk, callbackError, companyId);
      },

      _afterLogin: function (isLogged, callback) {
        this._clearTimeout();
        if (isLogged) {
          authFilter.init();
          this._setNewTimeout();
          authCompany.get(
            _.bind(authTrial.refresh, authTrial),
            authHandler.handle,
            authInfo.getCompanyId()
          );
        }
        if (callback) {
          callback(isLogged);
        }
      },

      _setNewTimeout: function () {
        var self = this,
          refreshTime = authInfo.getTimeToExpire() - TIME_BEFORE_EXPIRE;
        log('auth: refreshing in ' + refreshTime / 60000 + "'");
        this._timeout = setTimeout(function () {
          self._newLogin(function (isLogged) {
            self._afterLogin(isLogged);
          });
        }, refreshTime);
      },

      _clearTimeout: function () {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      },

      getCompanyInfo: function (callbackOk, callbackError) {
        var cid = lastCompanyId || authInfo.getCompanyId();
        authCompany.get(callbackOk, callbackError, cid);
      },
    };
  };
});

